import { DraftDesignConfiguration } from '@/types';
import { DesignUploadModalAction, ModalActionTypes, ModalTypes } from '../types';

export const designUploadModalAction = (
  configurations: DraftDesignConfiguration[],
  onCancel: () => void
): DesignUploadModalAction => ({
  type: ModalActionTypes.SHOW,
  modalType: ModalTypes.DESIGN_UPLOAD,
  props: { configurations, onCancel },
});
